import React from 'react';

const ChatHistoryLoader = () => (
  <div className="chat-history-loader" aria-live="polite" aria-busy="true">
    <div className="chat-history-loader-spinner" />
    <p>Loading conversation…</p>
  </div>
);

export default ChatHistoryLoader;
